import { apiPost, apiGet, getHostApi, hasPermission, parseQuery } from "../../store/apiWrapper";
import { bindActionCreators } from 'redux';
import { Circles } from "../common/loadingComponent";
import { connect } from "react-redux";
import { domainActions } from "../../store/domainStore";
import { filterMulti, findChildren } from "../../store/multiSelectFunction";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { Formik, Form } from 'formik';
import { pick } from 'lodash';
import { isNullOrUndefined } from '../../store/storeFunctions';
import { layoutActions } from "../../store/layoutStore";
import { marketingListActions, unicornCountry, unicornAttributes, unicornFinStatementTypes, unicornFinValuesIfrsConsolidated, unicornFinValuesIfrsIndividual, unicornFinValuesIfrsOriginal, unicornFinStatementOrganizationValues, unicornAttribute } from "../../store/marketingListStore";
import { popupActions } from "../../store/popupStore";
import { toast } from '../common/toast';
import { Translate, withLocalize } from "react-localize-redux";
import { withRouter } from "react-router";
import { Redirect } from 'react-router-dom'
import { writeErr } from '../common/logger';
import * as Yup from '../common/Yup';
import Activities from "./sections/activities";
import classnames from 'classnames'
import ColumnWrap from "./columnWrap";
import CommonInfo from "./sections/commonInfo";
import ExtendedSearchComponent from "../searchSections/extendedSearchComponent";
import Financial from "./sections/financial";
import MarketingSection from "./marketingSection";
import Message from "../common/message";
import moment from "moment";
import NavigationRow from "../layoutItems/navigationRow";
import Navigator from "./navigator";
import Rating from "./sections/rating";
import Msp from "./sections/msp";
import React from "react";
import Relations from "./sections/relations";
import Ess from "./sections/ess";
import TimeSeries from "./sections/timeSeries";
import Premises from "./sections/premises";
import Vehicles from "./sections/vehicles";
import WarningsAndAdditionInfo from "./sections/warningAndAdditional";

class MarketingListConfig extends React.Component {
    state = {
        config: null,
        isLoading: true,
        isLoadingRequest: false,
        isSaving: false,
        requestId: null,
        configId: null,
        essMethodology: ''
    }

    _sectionMap = {
        "common": (label, searchTip, errors) => <ColumnWrap key='common' style={{ padding: '.25em' }}>
            <MarketingSection name={this.props.translate(label)} isOpen={true} ><CommonInfo /></MarketingSection>
        </ColumnWrap>,
        "warnings": (label, searchTip, errors) => <ColumnWrap key='warnings' style={{ padding: '.25em' }}>
            <MarketingSection name={this.props.translate(label)} isOpen={true} ><WarningsAndAdditionInfo /></MarketingSection>
        </ColumnWrap>,
        "relations": (label, searchTip, errors) => <ColumnWrap key='relations' style={{ padding: '.25em' }}>
            <MarketingSection name={this.props.translate(label)} isOpen={true} ><Relations /></MarketingSection>
        </ColumnWrap>,
        "ess": (label, searchTip, errors) => <ColumnWrap key='ess' style={{ padding: '.25em' }}>
            <MarketingSection name={this.props.translate(label) + ' (' + this.props.translate(this.state.essMethodology) + ')'} isOpen={true} section="ess" errors={errors}><Ess updateEssLabel={this.updateEssLabel} /></MarketingSection>
        </ColumnWrap>,
        "activities": (label, searchTip, errors) => <ColumnWrap key='activities' style={{ padding: '.25em' }}>
            <MarketingSection name={this.props.translate(label)} isOpen={true} ><Activities /></MarketingSection>
        </ColumnWrap>,
        "rating": (label, searchTip, errors) => <ColumnWrap key='rating' style={{ padding: '.25em' }}>
            <MarketingSection name={this.props.translate(label)} isOpen={true} ><Rating /></MarketingSection>
        </ColumnWrap>,
        "financial": (label, searchTip, errors) => <ColumnWrap key='financial' style={{ padding: '.25em' }}>
            <MarketingSection name={this.props.translate(label)} isOpen={true} section="financial" searchTip={this.props.translate(searchTip)} errors={errors} ><Financial /></MarketingSection>
        </ColumnWrap>,
        "procurements": (label, searchTip, errors) => <ColumnWrap key='procurements' style={{ padding: '.25em' }}>
            <MarketingSection name={this.props.translate(label)} isOpen={true} section="extended" field="procurements" searchTip={this.props.translate(searchTip)} errors={errors} ><ExtendedSearchComponent field="procurements"></ExtendedSearchComponent></MarketingSection>
        </ColumnWrap>,
        "contracts": (label, searchTip, errors) => <ColumnWrap key='contracts' style={{ padding: '.25em' }}>
            <MarketingSection name={this.props.translate(label)} isOpen={true} section="extended" field="contracts" searchTip={this.props.translate(searchTip)} errors={errors} ><ExtendedSearchComponent field="contracts"></ExtendedSearchComponent></MarketingSection>
        </ColumnWrap>,
        "grants": (label, searchTip, errors) => <ColumnWrap key='grants' style={{ padding: '.25em' }}>
            <MarketingSection name={this.props.translate(label)} isOpen={true} section="extended" field="grants" searchTip={this.props.translate(searchTip)} errors={errors} ><ExtendedSearchComponent field="grants"></ExtendedSearchComponent></MarketingSection>
        </ColumnWrap>,
        "msp": (label, searchTip, errors) => <ColumnWrap key='msp' style={{ padding: '.25em' }}>
            <MarketingSection name={this.props.translate(label)} isOpen={true} section="msp" errors={errors} ><Msp /></MarketingSection>
        </ColumnWrap>,
        "timeSeries": (label, searchTip, errors) => <ColumnWrap key='timeSeries' style={{ padding: '.25em' }}>
            <MarketingSection name={this.props.translate(label)} isOpen={true} section="timeSeries" searchTip={this.props.translate(searchTip)} errors={errors} ><TimeSeries /></MarketingSection>
        </ColumnWrap>,
        "vehicles": (label, searchTip, errors) => <ColumnWrap key='vehicles' style={{ padding: '.25em' }}>
            <MarketingSection name={this.props.translate(label)} isOpen={true} section="vehicles" ><Vehicles /></MarketingSection>
        </ColumnWrap>,
        "premises": (label, searchTip, errors) => <ColumnWrap key='premises' style={{ padding: '.25em' }}>
            <MarketingSection name={this.props.translate(label)} isOpen={true} section="premises" ><Premises /></MarketingSection>
        </ColumnWrap>
    };

    componentDidMount() {
        this.props.resetExportSections();
        this.loadDomains();
    }

    componentWillUnmount() {
        if (this.searchStateLoader !== undefined) {
            window.clearTimeout(this.searchStateLoader);
        }
    }

    componentDidUpdate(prevProps) {
        if (this.props.marketingConfigDomainsLoaded && !this.state.isLoadingRequest && isNullOrUndefined(this.state.config)) {
            this.loadRequest();
        }
        if (prevProps.activeLanguage && this.props.activeLanguage.code !== prevProps.activeLanguage.code)
            this.loadDomains();
    }

    render() {
        if ((unicornCountry() === 'cz' && hasPermission(null, 'AccessCzechData'))
            || (unicornCountry() === 'sk' && hasPermission(null, 'AccessSlovakData')))
            return this.state.isLoading ? <Circles /> : this.renderForm();
        else
            return <Redirect to={`/notAuthorized?returnUrl=${encodeURIComponent(window.location.pathname + window.location.search)}`} />
    }

    updateEssLabel = () => {
            this.setState({essMethodology:  hasPermission(null, 'EconomicGroupSberbankMethodology') ? 'Report.Ess.SberbankMethodology' : 'Report.EconomicGroup.Settings.Title'});
    }

    createValidationSchema = (sections) => {
        const wrongCombinationMsg = this.props.translate("Error.WrongInputCombination");
        const wrongDateRange = this.props.translate('MarketingList.Error.DateRange');
        const wrongPositiveNumber = this.props.translate('MarketingList.Error.PositiveNumber');
        const wrongPositiveOrZeroNumber999 = this.props.translate('MarketingList.Error.PositiveOrZeroNumberMax');
        const number999 = 999999999999;
        const wrongHowManySk = this.props.translate('MarketingList.Error.HowManySk');
        const wrongHowManyCz = this.props.translate('MarketingList.Error.HowManyCz');
        const wrongYearFromSk = this.props.translate('MarketingList.Error.YearFromSk');
        const currentYear = new Date().getFullYear();
        const fromYearCz = currentYear - 11;
        const wrongYearFromCz = this.props.translate('MarketingList.Error.YearFromCz', { fromYear: fromYearCz, toYear: currentYear });
        const wrongValuesBetween = this.props.translate('MarketingList.Error.TimeSeries.Values');
        const wrongValuesBetweenEss = this.props.translate('MarketingList.Error.Ess.MinShareVals');
        const required = this.props.translate('Common.RequiredField');

        const schema = {
            'activities': Yup.object().test('marketingListCriteria', wrongCombinationMsg, function (item) {
                let section = sections["activities"];
                return isNullOrUndefined(item) || (!section.isChecked) || (item.nace || item.activities || item.trades);
            }),
            'rating': Yup.object().test('marketingListCriteria', wrongCombinationMsg, function (item) {
                let section = sections["rating"];
                return isNullOrUndefined(item) || (!section.isChecked) || (item.bankruptcy || item.creditCapacity || item.freeLoanLimitCons
                    || item.freeLoanLimitPro || item.groupSemaphore || item.index || item.loanLimitCons || item.loanLimitPro
                    || item.paymentDiscipline || item.semaphore || item.shortTermCreditCapacity);
            }),
            'financial': Yup.object().shape({
                option: Yup.string(),
                howMany: Yup.number().when('option', {
                    is: (val) => val === "last-x",
                    then: unicornCountry() === 'sk' ? Yup.number().min(0, wrongHowManySk).max(currentYear - 1993, wrongHowManySk) :
                        Yup.number().min(0, wrongHowManyCz).max(5, wrongHowManyCz),
                    otherwise: Yup.number(),
                }),
                yearFrom: Yup.number().when('option', {
                    is: (val) => val === "newer-than",
                    then: unicornCountry() === 'sk' ? Yup.number().min(1993, wrongYearFromSk).max(currentYear, wrongYearFromSk) :
                        Yup.number().min(fromYearCz, wrongYearFromCz).max(currentYear, wrongYearFromCz),
                    otherwise: Yup.number(),
                })
            }),
            'procurements': Yup.object().shape({
                'from': Yup.string().test('regFrom', wrongDateRange, (v) => dateInRange(v, sections["procurements"])).nullable(),
                'to': Yup.string().test('regTo', wrongDateRange, (v) => dateInRange(v, sections["procurements"])).nullable(),
                'countFrom': Yup.number().min(1, wrongPositiveNumber).transform(emptyStringToNull).nullable(),
                'countTo': Yup.number().min(1, wrongPositiveNumber).transform(emptyStringToNull).nullable(),
                'sumFrom': Yup.number().min(0, wrongPositiveOrZeroNumber999).max(number999, wrongPositiveOrZeroNumber999).transform(emptyStringToNull).nullable(),
                'sumTo': Yup.number().min(0, wrongPositiveOrZeroNumber999).max(number999, wrongPositiveOrZeroNumber999).transform(emptyStringToNull).nullable()
            }),
            'grants': Yup.object().shape({
                'from': Yup.string().test('regFrom', wrongDateRange, (v) => dateInRange(v, sections["grants"])).nullable(),
                'to': Yup.string().test('regTo', wrongDateRange, (v) => dateInRange(v, sections["grants"])).nullable(),
                'countFrom': Yup.number().min(1, wrongPositiveNumber).transform(emptyStringToNull).nullable(),
                'countTo': Yup.number().min(1, wrongPositiveNumber).transform(emptyStringToNull).nullable(),
                'sumFrom': Yup.number().min(0, wrongPositiveOrZeroNumber999).max(number999, wrongPositiveOrZeroNumber999).transform(emptyStringToNull).nullable(),
                'sumTo': Yup.number().min(0, wrongPositiveOrZeroNumber999).max(number999, wrongPositiveOrZeroNumber999).transform(emptyStringToNull).nullable()
            }),
            'contracts': Yup.object().shape({
                'from': Yup.string().test('regFrom', wrongDateRange, (v) => dateInRange(v, sections["contracts"])).nullable(),
                'to': Yup.string().test('regTo', wrongDateRange, (v) => dateInRange(v, sections["contracts"])).nullable(),
                'countFrom': Yup.number().min(1, wrongPositiveNumber).transform(emptyStringToNull).nullable(),
                'countTo': Yup.number().min(1, wrongPositiveNumber).transform(emptyStringToNull).nullable(),
                'sumFrom': Yup.number().min(0, wrongPositiveOrZeroNumber999).max(number999, wrongPositiveOrZeroNumber999).transform(emptyStringToNull).nullable(),
                'sumTo': Yup.number().min(0, wrongPositiveOrZeroNumber999).max(number999, wrongPositiveOrZeroNumber999).transform(emptyStringToNull).nullable()
            }),
            'timeSeries': Yup.object().shape({
                'lastX': Yup.number().typeError(required).min(1, wrongValuesBetween).max(10, wrongValuesBetween),
            }),
            'ess': Yup.object().shape({
                'minShare': Yup.number().typeError(required).min(0, wrongValuesBetweenEss).max(100, wrongValuesBetweenEss),
            }),
        }

        let sectionToValidate = [/*'activities', 'rating',*/ 'financial', 'procurements', 'grants', 'contracts', 'timeSeries', 'ess']
        let validatedSectionsArr = [];

        sectionToValidate.forEach(s => {
            if (sections[s].isChecked)
                validatedSectionsArr.push(s);
        });

        return Yup.object().shape(pick(schema, validatedSectionsArr));
    }

    renderForm() {
        const fromPopup = (this.props.location.state || {}).fromPopup || false;
        const keys = Object.keys(this.props.ml.exportSections);

        return (
            <>
                <div className="content-root">
                    <Navigator isEditing={this.state.isEditing} />
                    <div>
                        <div className="columns is-multiline ">
                            {<Formik
                                enableReinitialize={true}
                                validationSchema={this.createValidationSchema(this.props.ml.exportSections)}
                                validateOnChange={false}
                                validateOnBlur={false}
                                initialValues={this.props.ml.exportSections}
                                onSubmit={(values, actions) => this.submitConfig(values, actions)}
                            >
                                {({ errors }) => (
                                    <Form noValidate style={{ width: "100%", padding: "2em 2em 1em" }} >
                                        {!fromPopup && <>
                                            {keys.filter(x => x === 'common' && (this.props.ml.exportSections[x].role === null ||
                                                hasPermission(null, this.props.ml.exportSections[x].role)) &&
                                                this.props.ml.exportSections[x].isChecked)
                                                .sort((a, b) => this.props.ml.exportSections[a].order - this.props.ml.exportSections[b].order)
                                                .map(s => this._sectionMap[s](this.props.ml.exportSections[s].label, this.props.ml.exportSections[s].searchTip, errors))}
                                            {keys.filter(x => (this.props.ml.exportSections[x].role === null || hasPermission(null, this.props.ml.exportSections[x].role)) &&
                                                this.props.ml.exportSections[x].isChecked).length > 2 && <ColumnWrap style={{ padding: '.25em' }}>
                                                    <Message type="warning" message={this.props.translate("Marketing.Config.MultipleFiles")} />
                                                </ColumnWrap>}
                                            {keys.filter(x => x !== 'common' && (this.props.ml.exportSections[x].role === null ||
                                                hasPermission(null, this.props.ml.exportSections[x].role)) &&
                                                this.props.ml.exportSections[x].isChecked)
                                                .sort((a, b) => this.props.ml.exportSections[a].order - this.props.ml.exportSections[b].order)
                                                .map(s => this._sectionMap[s](this.props.ml.exportSections[s].label, this.props.ml.exportSections[s].searchTip, errors))}
                                        </>}
                                        {fromPopup && <Circles />}
                                        <button data-redirect="results" id="fake-submit-config" type="submit" style={{ display: "none" }} />
                                    </Form>
                                )}
                            </Formik>
                            }
                        </div>
                    </div>
                </div>
                <NavigationRow justify="space-between">
                    <div>
                        {this.isEditingRequest() && this.state.canEditSearch &&
                            <button className={classnames('bb-button gradient-1-gray', { 'is-square': localStorage.locales_button_style === 'square' })}
                                type="button"
                                onClick={() => isNullOrUndefined(this.state.configId) ?
                                    this.props.redirectTo(`/unicorn/${unicornCountry()}/parameters?requestId=${parseQuery(this.props.location.search).requestId}`) :
                                    this.props.redirectTo(`/unicorn/${unicornCountry()}/parameters?requestId=${parseQuery(this.props.location.search).requestId}&configId=${this.state.configId}`)}
                            >
                                <Translate id="Marketing.Navigation.BackToCriteria" />
                            </button>
                        }
                    </div>
                    {this.state.searchState !== 'Template' && <div><Translate id='Marketing.Navigation.SubjectCount' />:&nbsp;
                        {this.state.searchState === 'SearchCompleted' && this.state.searchCount}
                        {this.state.searchState !== 'SearchCompleted' && <FontAwesomeIcon icon='cog' spin={true} />}
                    </div>}
                    <button onClick={() => document.querySelector("#fake-submit-config").click()}
                        className={classnames('bb-button gradient-1', { 'is-square': localStorage.locales_button_style === 'square' })}
                        type="button"
                    >
                        <Translate id={this.state.searchState === 'Template' ? "Common.Button.Save" : "Marketing.Navigation.ConfirmConfig"}></Translate>
                    </button>
                </NavigationRow>
            </>
        );
    }

    isEditingRequest() {
        return parseQuery(this.props.location.search).requestId !== undefined;
    }

    hasCheckedSection() {
        //common info always checked
        return Object.entries(this.props.ml.exportSections).filter(s => s[1].isChecked).length > 1;
    }

    submitConfig(values, actions) {
        this.setState({ isSaving: true });
        let copied = JSON.parse(JSON.stringify(values));
        copied = this.markSections(copied);
        filterMulti(copied.warnings.warnings, this.props['warning-types'], true);
        filterMulti(copied.warnings.additional, this.props['additional-info'], true);
        filterMulti(copied.warnings.sources, this.props.sources, true);
        filterMulti(copied.relations, this.props.relations, true);
        if (unicornCountry() === 'cz')
            filterMulti(copied.vehicles.categories, this.props['vehicle-categories'], true);
        this.transformForPost(copied);

        let urlToRedirect = document.querySelector("#fake-submit-config").getAttribute("data-redirect") === "params" ?
            `/unicorn/${unicornCountry()}/parameters?requestId=${this.state.requestId}` : `/unicorn/${unicornCountry()}/${this.state.searchState === 'Template' ? 'templates' : 'results'}`;

        const data = { config: JSON.stringify(copied).replace(/'/g, "\\'").replace(/"/g, "'"), requestId: parseInt(this.state.requestId, 10), configId: parseInt(this.state.configId, 10), country: unicornCountry() };
        if (this.state.searchState === 'New' || this.state.searchState === 'ProcessingSearch') {
            toast(this.props.translate("Marketing.SearchInProgress"), "info");
        }

        apiPost(`${getHostApi()}/api/marketing-list/save-config`, null, data,
            () => this.props.redirectTo(urlToRedirect),
            (r) => writeErr(r),
            () => this.setState({ isSaving: false }))
    }

    //sections are in state, we need to pass to server as well
    markSections(copiedValues) {
        copiedValues.common.isChecked = true;
        copiedValues.warnings.isChecked = this.props.ml.exportSections["warnings"].isChecked;
        copiedValues.financial.isChecked = this.props.ml.exportSections["financial"].isChecked;
        copiedValues.relations.isChecked = this.props.ml.exportSections["relations"].isChecked;
        copiedValues.ess.isChecked = this.props.ml.exportSections["ess"].isChecked;
        copiedValues.rating.isChecked = this.props.ml.exportSections["rating"].isChecked;
        copiedValues.procurements.isChecked = this.props.ml.exportSections["procurements"].isChecked;
        copiedValues.contracts.isChecked = this.props.ml.exportSections["contracts"].isChecked;
        copiedValues.grants.isChecked = this.props.ml.exportSections["grants"].isChecked;
        copiedValues.activities.isChecked = this.props.ml.exportSections["activities"].isChecked;
        copiedValues.timeSeries.isChecked = this.props.ml.exportSections["timeSeries"].isChecked;
        copiedValues.msp.isChecked = this.props.ml.exportSections["msp"].isChecked;

        copiedValues.vehicles.isChecked = this.props.ml.exportSections["vehicles"].isChecked;
        copiedValues.premises.isChecked = this.props.ml.exportSections["premises"].isChecked;
        return copiedValues;
    }

    transformForPost(copiedValues) {
        this.sanitizeExtended(copiedValues.procurements);
        this.sanitizeExtended(copiedValues.contracts);
        this.sanitizeExtended(copiedValues.grants);
    }

    sanitizeExtended = (obj) => {
        obj.from = this.filterDate(obj.from);
        obj.to = this.filterDate(obj.to);
        obj.countFrom = this.toInt(obj.countFrom);
        obj.countTo = this.toInt(obj.countTo)
        obj.sumFrom = this.toInt(obj.sumFrom)
        obj.sumTo = this.toInt(obj.sumTo)
    }

    filterDate(obj) {
        return isNullOrUndefined(obj) || obj === "" ? null : moment(obj, "DD.MM.YYYY").toISOString();
    }

    toInt(field) {
        return parseInt(field, 10) || null
    }

    loadDomains() {
        if (parseQuery(this.props.location.search).requestId === undefined) {
            this.props.redirectTo(`/unicorn/${unicornCountry()}/parameters`);
        }

        if (!this.props.marketingConfigDomainsLoaded || this.props.marketingConfigDomainsCountry !== unicornCountry()) {
            this.props.setMarketingConfigDomainsCountry(unicornCountry());
            this.props.ensureDomainData('additional-info', { marketAttributes: unicornAttributes() });
            this.props.ensureDomainData('warning-types', { marketAttributes: unicornAttributes() });
            this.props.ensureDomainData('sources', { marketAttributes: unicornAttributes() });
            this.props.ensureDomainData('relations', { marketAttributes: unicornAttributes() });
            this.props.ensureDomainData('fin-statement-ratios', { marketAttributes: unicornAttributes() });
            this.props.ensureDomainData('fin-statement-types', { types: unicornFinStatementTypes() });
            if (unicornCountry() === "sk") {
                this.props.ensureDomainData('fin-statement-types-ifrs-consolidated', { types: unicornFinValuesIfrsConsolidated() });
                this.props.ensureDomainData('fin-statement-types-ifrs-individual', { types: unicornFinValuesIfrsIndividual() });
                this.props.ensureDomainData('fin-statement-types-ifrs-orig', { types: unicornFinValuesIfrsOriginal() });
                this.props.ensureDomainData('fin-statement-values-organizations-values-sasp', { marketAttribute: unicornAttribute(), finStatementTypes: unicornFinStatementOrganizationValues() });
                this.props.ensureDomainData('fin-statement-values-organizations-values-v', { marketAttribute: unicornAttribute(), finStatementTypes: unicornFinStatementOrganizationValues() });
                this.props.ensureDomainData('fin-statement-values-organizations-values-vh', { marketAttribute: unicornAttribute(), finStatementTypes: unicornFinStatementOrganizationValues() });
                this.props.ensureDomainData('fin-statement-values-organizations-values-vp', { marketAttribute: unicornAttribute(), finStatementTypes: unicornFinStatementOrganizationValues() });  
                this.props.ensureDomainData('fin-statement-values-organizations-values-all', { marketAttribute: unicornAttribute(), finStatementTypes: unicornFinStatementOrganizationValues() }); 
            }
            if (unicornCountry() === "cz") {
                this.props.ensureDomainData('vehicle-categories');
            }
        }
    }

    loadRequest() {
        this.setState({ isLoadingRequest: true });
        let params = `?country=${unicornCountry()}`
        let qs = parseQuery(this.props.location.search);
        if (!isNullOrUndefined(qs.configId)) {
            this.setState({ requestId: qs.requestId, configId: qs.configId })
            params += `&configId=${qs.configId}`;
        } else {
            this.setState({ requestId: qs.requestId });
        }
        apiGet(`${getHostApi()}/api/marketing-list/config${params}`, null, (r) => { this.getDataSuccess(r); this.loadSearchState(); }, (r) => writeErr(r));
    }

    loadSearchState = () => {
        apiGet(`${getHostApi()}/api/marketing-list/requests/${parseQuery(this.props.location.search).requestId}`, null, (res) => {
            if (!res.data.canEditExport) {
                this.props.redirectTo(`/unicorn/${unicornCountry()}/parameters`);
                return;
            }
            this.setState({ searchState: res.data.state, searchCount: res.data.count, canEditSearch: res.data.canEditSearch });
            if (res.data.state !== 'SearchCompleted') {
                this.searchStateLoader = window.setTimeout(() => this.loadSearchState(), 5000);
            }
        }, (err) => {
            writeErr(err);
        });
    }

    getDataSuccess(data) {
        // If config is loaded from server then merge it into the default values to ensure functionality in case when default schema is different from saved config's schema
        // All matching properties are set to values from server, others (changed) remain default
        var json = null;
        try { json = JSON.parse(data.data.replace(/'/g, '"').replace(/\\"/g, "'")); } catch { json = null; }
        let fromServer = !isNullOrUndefined(json) ? json : Object.assign({}, this.props.ml.exportSections);
        let sec = { ...this.props.ml.exportSections };

        sec.common = { ...sec.common, ...{ ...fromServer.common, order: sec.common.order, label: sec.common.label }, isChecked: true };
        sec.warnings = { ...sec.warnings, ...fromServer.warnings };
        sec.relations = { ...sec.relations, ...fromServer.relations };
        sec.ess = { ...sec.ess, ...fromServer.ess };
        sec.activities = { ...sec.activities, ...fromServer.activities };
        sec.rating = { ...sec.rating, ...fromServer.rating };
        sec.financial = { ...sec.financial, ...fromServer.financial };
        sec.procurements = { ...sec.procurements, ...fromServer.procurements, ...this.loadExtended(fromServer.procurements) };
        sec.contracts = { ...sec.contracts, ...fromServer.contracts, ...this.loadExtended(fromServer.contracts) };
        sec.grants = { ...sec.grants, ...fromServer.grants, ...this.loadExtended(fromServer.grants) };
        sec.timeSeries = { ...sec.timeSeries, ...fromServer.timeSeries };
        sec.msp = { ...sec.msp, ...fromServer.msp };
        sec.vehicles = { ...sec.vehicles, ...fromServer.vehicles };
        if (sec.vehicles.categories.allSelected) {
            sec.vehicles.categories.all = [];
            this.props["vehicle-categories"].requestResult.forEach(r => findChildren(r, sec.vehicles.categories.all, false));
        }
        sec.premises = { ...sec.premises, ...fromServer.premises };

        this.setState({ config: fromServer, isLoading: false, isLoadingRequest: false },
            () => {
                if ((this.props.location.state || {}).fromPopup || false) {
                    document.querySelector("#fake-submit-config").click();
                }
            });
        this.props.setExportSections(sec);
    }

    loadExtended = (obj) => {
        return {
            from: this.loadDate(obj.from),
            to: this.loadDate(obj.to)
        }
    }

    loadDate(obj) {
        return isNullOrUndefined(obj) ? "" : moment(obj).format("DD.MM.YYYY");
    }
}

function dateInRange(value, section, format = "DD.MM.YYYY") {
    let result = isNullOrUndefined(value) || !section.isChecked || value === "";
    if (!result) {
        let formatted = isNullOrUndefined(format) ? moment(value) : moment(value, format);
        let now = moment();
        let result = formatted.isAfter(moment("31.12.1899", "DD.MM.YYYY")) && (formatted.isBefore(now) || formatted.isSame(now));
        return result;
    }
    return result;
}

function emptyStringToNull(value, originalValue) {
    if (typeof originalValue === 'string' && originalValue === '') {
        return null;
    }
    return value;
}

export default withRouter(withLocalize(connect(
    state => { return { ...state.domain, ml: state.marketingList } },
    dispatch => bindActionCreators(Object.assign({}, domainActions, popupActions, layoutActions, marketingListActions), dispatch)
)(MarketingListConfig)));
